import React, { Component } from "react";
import { connect } from "react-redux";
import { metadataService, ServiceUtil } from "../../_services";
import {
  Card,
  CardBody,
  CardHeader,
  Row,
  Col,
  Collapse,
  Alert,
} from "reactstrap";
import { DocumentApi } from "../../_services";
import {
  SlPageTitle,
  SlBusyIndicator,
  SlInfoIcon,
  SLSvgEmail,
  SLSvgPhone,
} from "../editors";
import { FaRegIdCard, FaFileAlt, FaInfoCircle } from "react-icons/fa";
import DocumentUpload from "../DocumentUpload";
import { documentActions } from "../../_actions";
import { loanInfoActions } from "../../_actions/loanInfo.actions";
import NotificationModal from "./NotificationModal";
import DocumentList from "./DocumentList";
import Persona from './Persona';

class LeadDocuments extends Component {
  constructor(props) {
    super(props);

    this.state = {
      notificationModalOpen: false,
      notificationModalMessage: "",
      documentUploadInfo: null,
      showPersona: props.usePersona && (!props.proofsOfIdentity || props.proofsOfIdentity.length === 0)
      };

    this.openNotificationModal = this.openNotificationModal.bind(this);
    this.closeNotificationModal = this.closeNotificationModal.bind(this);
  }

  componentDidMount() {
    
  }

  downloadDocument = (doc) => {

    this.props.actions.downloadDocument(doc);
    // if (!doc.isViewed) {
    //   this.markDocumentAsViewed(doc);
    // }
    // DocumentApi.getFile(doc.id).then((response) => {
    //   let link = document.createElement("a");
    //   link.href = "data:image/png;base64," + response.data;
    //   link.download = `${doc.documentName}`;
    //   link.click();
    //   setTimeout(function () {
    //     window.URL.revokeObjectURL(link);
    //   }, 200);
    // });
  };

  markDocumentAsViewed(doc) {
    this.props.actions.markDocumentAsViewed(doc);
  }

  closeNotificationModal() {
    this.setState({
      notificationModalOpen: false,
      notificationModalMessage: "",
    });
  }

  openNotificationModal(savedDocument) {
    if (savedDocument) {
      let documentClassificationText = "";
      switch (savedDocument.DocumentClassification) {
        case DocumentApi.DOCUMENT_CLASSIFICATION_IDENTITYFRONT:
          documentClassificationText =
            metadataService.getTitle("ProofOfIdentity");
          break;
        case DocumentApi.DOCUMENT_CLASSIFICATION_INCOME:
          documentClassificationText =
            metadataService.getTitle("ProofOfIncome");
          break;
        case DocumentApi.DOCUMENT_CLASSIFICATION_RESIDENCE:
          documentClassificationText =
            metadataService.getTitle("ProofOfResidence");
          break;
        default:
          break;
      }
      this.setState({
        notificationModalOpen: true,
        notificationModalMessage: metadataService.getMessage(
          "DocumentProofSubmitted",
          documentClassificationText
        ),
      });
      this.props.actions.documentUploadOnDone(savedDocument);
    }
  }
  render() {
    const {
      proofsOfIdentity,
      proofsOfResidence,
      proofsOfIncome,
      leadDocumentsLoading,
      leadId,
      documentUploadInfo,
      userHash,
      isSMSForDocumentsEnabled,
      usePersona
    } = this.props;
    const {
      notificationModalMessage,
        notificationModalOpen,
      showPersona
    } = this.state;
    return (
      <div>
        <h6 className="pb-3">
            {metadataService.getTitle("ConfirmationApplicationReceived")}
        </h6>

        <p>
            {metadataService.getMessage("PleaseCompleteSteps")}
            <ul>
                <li>{metadataService.getMessage("PleaseCompleteSteps1")}</li>
                <li>{metadataService.getMessage("PleaseCompleteSteps2")}</li>
                <li>{metadataService.getMessage("PleaseCompleteSteps3")}</li>
            </ul>
        </p>

        <SlBusyIndicator visible={leadDocumentsLoading} />
        {leadDocumentsLoading == false && (
            <div>
                {usePersona === true ?
                        (showPersona === true && proofsOfIdentity.length === 0) ?
                            <Row>
                                <Persona leadId={leadId} onComplete={() => this.setState({ showPersona: false })} />
                            </Row>
                            : <DocumentCard
                                documents={proofsOfIdentity}
                                viewDocument={this.downloadDocument}
                                leadId={leadId}
                                documentClassificationId={
                                    DocumentApi.DOCUMENT_CLASSIFICATION_IDENTITYFRONT
                                }
                                openNotificationModal={this.openNotificationModal}
                                userHash={userHash}
                                uploadsEnabled={false}
                            />
                    : <DocumentCard
                        documents={proofsOfIdentity}
                        viewDocument={this.downloadDocument}
                        leadId={leadId}
                        documentClassificationId={
                            DocumentApi.DOCUMENT_CLASSIFICATION_IDENTITYFRONT
                        }
                        openNotificationModal={this.openNotificationModal}
                        userHash={userHash}
                    />
                }

            <DocumentCard
              documents={proofsOfIncome}
              viewDocument={this.downloadDocument}
              leadId={leadId}
              documentClassificationId={
                DocumentApi.DOCUMENT_CLASSIFICATION_INCOME
              }
              openNotificationModal={this.openNotificationModal}
              maxAllowedFiles={2}
              userHash={userHash}
            />
            <DocumentCard
              documents={proofsOfResidence}
              viewDocument={this.downloadDocument}
              leadId={leadId}
              documentClassificationId={
                DocumentApi.DOCUMENT_CLASSIFICATION_RESIDENCE
              }
              openNotificationModal={this.openNotificationModal}
              maxAllowedFiles={2}
              userHash={userHash}
            />
          </div>
        )}

        <NotificationModal
          open={notificationModalOpen}
          ok={this.closeNotificationModal}
          message={notificationModalMessage}
        />
      </div>
    );
  }
}
export const DocumentCard = ({
  documents = [],
  viewDocument,
  leadId,
  documentClassificationId,
  openNotificationModal,
maxAllowedFiles = 1,
uploadsEnabled = true,
  userHash,
}) => {
  const getTitle = () => {
    switch (documentClassificationId) {
      case DocumentApi.DOCUMENT_CLASSIFICATION_IDENTITYFRONT:
        return metadataService.getTitle("ProofOfIdentity");
      case DocumentApi.DOCUMENT_CLASSIFICATION_INCOME:
        return metadataService.getTitle("ProofOfIncome");
      case DocumentApi.DOCUMENT_CLASSIFICATION_RESIDENCE:
        return metadataService.getTitle("ProofOfResidence");
      default:
        return "";
    }
  };
  const getLeftIcon = () => {
    switch (documentClassificationId) {
      case DocumentApi.DOCUMENT_CLASSIFICATION_IDENTITYFRONT:
        return <FaRegIdCard size={60} />;
      case DocumentApi.DOCUMENT_CLASSIFICATION_INCOME:
        return <FaFileAlt size={60} />;
      case DocumentApi.DOCUMENT_CLASSIFICATION_RESIDENCE:
        return <FaFileAlt size={60} />;
      default:
        return <FaFileAlt size={60} />;
    }
  };
  const getMessage = () => {
    switch (documentClassificationId) {
      case DocumentApi.DOCUMENT_CLASSIFICATION_IDENTITYFRONT:
        return metadataService.getMessage("ProofOfIdentity");
      case DocumentApi.DOCUMENT_CLASSIFICATION_INCOME:
        return metadataService.getMessage("ProofOfIncome");
      case DocumentApi.DOCUMENT_CLASSIFICATION_RESIDENCE:
        return metadataService.getMessage("ProofOfResidence");
      default:
        return "";
    }
  };
  const documentsAccepted = documents.filter(
    (doc) => doc.documentStatusId === DocumentApi.DOCUMENT_STATUS_ACCEPTED
    );

    const documentsUploaded = documents.filter(
        (doc) => doc.documentStatusId !== DocumentApi.DOCUMENT_STATUS_REJECTED
    );

    const allDocsUploaded = documentsUploaded.length >= maxAllowedFiles;
    const allDocsAccepted = documentsAccepted.length > 0 && documentsAccepted.length >= maxAllowedFiles;

  return (
    <div>
      <Card className="ml-0 pl-0 mb-3">
        <CardBody className="border ml-0">
          <p className="text-center">
            <strong>{getTitle()}</strong>
         </p>

        <div className="justify-content-center text-center">
            {(!uploadsEnabled || allDocsUploaded || allDocsAccepted) &&
                <h6 className="font-style-bold">
                    {metadataService.getMessage("ThankYou")}
                </h6>
            }

            {allDocsAccepted ? (
                    <p>
                        {metadataService.getMessage(
                            "VerifiedAt",
                            metadataService.formatDateString(
                                documentsAccepted[0].modifiedTime
                            )
                        )}
                    </p>
            ) : uploadsEnabled && (
            <p>
                {metadataService.getMessage(
                    "DocumentsUploaded",
                    documentsUploaded.length.toString(),
                    maxAllowedFiles.toString()
                )}
            </p>
            )}
            </div>

                  

          {uploadsEnabled && !allDocsUploaded && (
            <div>
              <p>{getMessage()}</p>
              <Row>
                <Col>
                  <DocumentUpload
                    uploadTitle={getTitle()}
                    hideTitle={true}
                    hideStatus={true}
                    leadId={leadId}
                    origin={DocumentApi.DOCUMENT_ORIGIN_UPLOAD}
                    documentStatus={""}
                    documentStatusClass={""}
                    documentClassification={documentClassificationId}
                    onDone={openNotificationModal}
                    hideDropZone={false}
                    lastModified={""}
                    maxAllowedFiles={maxAllowedFiles}
                    restoreOnDone={true}
                    userHash={userHash}
                  />
                </Col>
              </Row>
            </div>
            )}


          {documents.length > 0 && !allDocsAccepted && (
            <Row>
              <Col>
                <DocumentList
                  dataSource={documents}
                  openFileNewTab={viewDocument}
                  leftContent={<i>{getLeftIcon()}</i>}
                />
              </Col>
            </Row>
            )}
            
              
            
        </CardBody>
      </Card>
    </div>
  );
};

const mapStateToProps = (state) => {
  const {
    idDocuments,
    proofsOfIdentity,
    proofsOfResidence,
    proofsOfIncome,
    idDocumentsLoading,
    leadId,
    userHash,
  } = state.documents;
  const { language } = state.users;
  const { documentUploadInfo } = state.configuration;
  return {
    idDocsRejected: state.documents.idDocsRejected,
    hasActiveLeads: state.loanInfo.accountViews
      ? state.loanInfo.accountViews.hasActiveLeads
      : false,
    leadDocumentsByUser: idDocuments,
    proofsOfIdentity,
    proofsOfResidence,
    proofsOfIncome,
    leadDocumentsLoading: idDocumentsLoading,
    leadId,
    language,
    documentUploadInfo,
    userHash
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: {
      loadLeadDocumentsByUser: () => {
        dispatch(documentActions.loadLeadDocumentsByUser());
      },
      markDocumentAsViewed: (doc) => {
        dispatch(documentActions.markDocumentAsViewed(doc));
      },
      downloadDocument: (doc) => {
        dispatch(documentActions.downloadDocument(doc));
      },
      documentUploadOnDone: (doc) => {
        dispatch(documentActions.documentUploadOnDone(doc));
      },
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LeadDocuments);
